import { Injectable } from '@angular/core';
import { forkJoin, Observable, of, throwError } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { AllPromoations, AllPromoationsInput, InviteAndEarnPromotion, VerifyAndEarnPromotion } from '../models/promotions';
import { TierOneStatusType } from '../models/tier-one';
import { ApiService } from './api.service';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class PromotionsService {

  private verifyAndEarnQuery = `
    verifyAndEarnPromotion {
      type
      promotionEnabled
      status
      endDate
      minDeposit {
        amount
        currency
      }
      reward {
        amount
        currency
      }
    }
  `;

  constructor(private api: ApiService, private auth: AuthService) {
  }

  verifyAndEarn(): Observable<VerifyAndEarnPromotion> {
    return this.api.get(`query verifyAndEarnPromotion {
     ${this.verifyAndEarnQuery}
    }`, null, this.auth.getToken() ? true : false).pipe(
      switchMap(response => {
        if (response['errors']) {
          return throwError(response);
        }

        return of(response['data']['verifyAndEarnPromotion']);
      }),
      this.api.unifyErrors()
    );
  }

  verifyAndEarnWithTierOne(): Observable<{ verifyAndEarn: VerifyAndEarnPromotion, tierOneStatus: TierOneStatusType }> {
    return this.api.get(`query verifyAndEarnWithTierOne {
      ${this.verifyAndEarnQuery}
      t1VerificationRequestStatus {
        request{
          status
        }
      }
     }`, null, this.auth.getToken() ? true : false).pipe(
      switchMap((response: any) => {
        if (response['errors']) {
          return throwError(response);
        }

        return of({
          verifyAndEarn: response?.data?.verifyAndEarnPromotion,
          tierOneStatus: response?.data?.t1VerificationRequestStatus?.request?.status
        });
      }),
      this.api.unifyErrors()
    );
  }

  getReferralDetails(referralId: string): Observable<InviteAndEarnPromotion> {
    return this.api.get(`query referrerDetail($referralId: String!) {
      referrerDetail(referralId: $referralId) {
        firstName
      }
     }`, {
      referralId
     }, this.auth.getToken() ? true : false).pipe(
      switchMap((response: any) => {
        if (response['errors']) {
          return throwError(response);
        }

        return of(response['data']?.['referrerDetail']);
      }),
      this.api.unifyErrors()
    );
  }

  getAllPromotions(data: AllPromoationsInput): Observable<AllPromoations> {
    return forkJoin({
      verifyAndEarn: this.verifyAndEarn(),
      inviteAndEarn: data?.inviteAndEarn?.referralId ? this.getReferralDetails(data?.inviteAndEarn?.referralId) : of(null)
    });
  }
}
